export default "__VITE_ASSET__847e0933__"